(() => {
  if (window.__dtxDingdoongPreselectBound) return;
  window.__dtxDingdoongPreselectBound = true;

  const TARGET_METHOD = 'delivery';
  const PRESELECT_FLAG = '__dtx_dingdoong_preselect_local_delivery_applied__';

  const applyPreselect = () => {
    const mf = window.dingdoongAppMetafields;
    const sg = mf?.data?.shopGeneral;
    if (!sg || window[PRESELECT_FLAG]) return;
    if (sg.defaultMethod !== TARGET_METHOD) sg.defaultMethod = TARGET_METHOD;
    if (mf?.data?.appearance && mf.data.appearance.defaultMethod !== undefined) {
      mf.data.appearance.defaultMethod = TARGET_METHOD;
    }
    window[PRESELECT_FLAG] = true;
  };

  // One-shot, idle — no MutationObserver / interval (those froze the cart).
  const boot = () => {
    try {
      applyPreselect();
    } catch (_) {}
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(boot, { timeout: 5000 });
  } else {
    window.setTimeout(boot, 1500);
  }
})();
